module.exports = __webpack_public_path__ + "static/media/Ellipse.100c2d12.svg";